var _rect, _path, _rect2, _rect3, _circle, _rect4, _rect5, _path2, _rect6, _path3, _rect7, _path4, _path5, _rect8, _rect9, _circle2, _path6, _circle3, _circle4, _path7, _path8, _path9, _circle5, _circle6, _path10, _path11, _path12, _path13, _g, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAonAdvancedSetupMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 364,
    height: 217,
    fill: "none",
    viewBox: "0 0 364 217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 358,
    height: 210.588,
    x: 3,
    y: 1,
    fill: "#fff",
    rx: 8.179
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m322.948 63.815-24.741-7.206a4.067 4.067 0 0 1 2.289 4.78l-33.761 125.443a4.242 4.242 0 0 1-4.276 3.136l24.745 6.66 35.744-132.813Z",
    opacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 99.885,
    height: 137.539,
    x: 265.81,
    y: 190.599,
    stroke: "#5C5C5C",
    strokeWidth: 0.523,
    rx: 3.922,
    transform: "rotate(-164.937 265.81 190.599)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 94.656,
    height: 124.465,
    x: 265.052,
    y: 183.355,
    stroke: "#C6C6C6",
    strokeWidth: 0.523,
    rx: 3.922,
    transform: "rotate(-164.937 265.052 183.355)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 218.105,
    cy: 174.904,
    r: 1.054,
    stroke: "#4D4D4D",
    strokeWidth: 0.523,
    transform: "rotate(15.063 218.105 174.904)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 48.112,
    height: 20.918,
    x: 235.286,
    y: 60.531,
    stroke: "url(#d)",
    strokeWidth: 0.523,
    opacity: 0.3,
    rx: 2.353,
    transform: "rotate(15.063 235.286 60.531)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 48.686,
    height: 12.281,
    x: 187.931,
    y: 136.875,
    fill: "#4D4D4D",
    opacity: 0.3,
    rx: 2.615,
    transform: "rotate(15.063 187.931 136.875)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.523,
    d: "m191.027 142.25 16.941 4.559M190.115 145.638l30.918 8.321"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 48.112,
    height: 20.918,
    x: 202.386,
    y: 84.171,
    stroke: "#000",
    strokeWidth: 0.523,
    opacity: 0.3,
    rx: 2.353,
    transform: "rotate(15.063 202.386 84.171)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeWidth: 0.523,
    d: "m204.903 95.95 16.941 4.56M205.718 92.92l16.942 4.56M203.991 99.339l30.918 8.321"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 48.112,
    height: 12.551,
    x: 223.318,
    y: 130.151,
    fill: "#4D4D4D",
    rx: 2.615,
    transform: "rotate(15.063 223.318 130.151)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.523,
    d: "m226.413 135.526 8.471 2.28m8.471 2.28-4.871-1.311M225.501 138.915l30.919 8.321"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m137.343 136.144-21.958 5.368a3.755 3.755 0 0 1 2.697 2.592l10.864 37.153c0 1.43-.872 2.716-2.2 3.246l-2.679 1.07 25.659-7.282-12.383-42.147Z",
    opacity: 0.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 45.762,
    height: 83.632,
    x: 49.643,
    y: 207.757,
    stroke: "url(#f)",
    strokeWidth: 0.523,
    rx: 3.922,
    transform: "rotate(-106.373 49.643 207.757)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 40.082,
    height: 75.216,
    x: 53.835,
    y: 204.113,
    fill: "url(#g)",
    stroke: "url(#h)",
    strokeWidth: 0.523,
    opacity: 0.3,
    rx: 3.922,
    transform: "rotate(-106.373 53.835 204.113)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.704,
    cy: 38.597,
    r: 26.813,
    stroke: "url(#i)",
    strokeWidth: 0.523,
    transform: "rotate(15 74.704 38.597)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeWidth: 0.523,
    d: "m84.874 52.399 3.743 3.76a2.235 2.235 0 0 0 3.167-3.153l-3.75-3.767"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.661,
    cy: 38.523,
    r: 17.13,
    stroke: "#5C5C5C",
    strokeWidth: 0.523,
    transform: "rotate(-45 74.66 38.523)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.661,
    cy: 38.523,
    r: 14.896,
    fill: "url(#j)",
    transform: "rotate(-45 74.66 38.523)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#k)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.523,
    d: "m147.674-6.773-19.559 38.62-7.935 8.751 1.071-11.53 18.667-38.015"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.523,
    d: "M128.115 31.847c-.806-1.19-3.237-3.215-6.864-2.779M123.947 36.435l-3.594 1.594"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "m119.301 37.942 1.406-1.992.454-7.127 14.996-30.546-3.713-2.54-13.942 32.667-.151 9.228c-.009.515.653.73.95.31Z",
    opacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.688,
    cy: 95.406,
    r: 0.264,
    stroke: "#4D4D4D",
    strokeWidth: 0.518,
    transform: "rotate(-1.825 122.688 95.406)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.781,
    cy: 96.537,
    r: 36.607,
    stroke: "#4D4D4D",
    strokeDasharray: "1.05 1.05",
    strokeWidth: 0.523,
    opacity: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeWidth: 0.523,
    d: "M188.87 91.307c-2.628-27.005-25.394-48.112-53.089-48.112-29.46 0-53.342 23.882-53.342 53.342 0 19.612 10.585 36.753 26.353 46.02m10.254 4.644a53.282 53.282 0 0 0 16.735 2.678c17.893 0 33.729-8.811 43.406-22.33",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeDasharray: "1.05 1.05",
    strokeWidth: 0.523,
    d: "M197.678 59.407c-12.621-20.993-35.619-35.039-61.897-35.039-1.228 0-2.448.031-3.661.092m38.39 135.355c-10.303 5.667-22.14 8.891-34.729 8.891-3.552 0-7.045-.257-10.459-.753m-38.72-18.597c-14.144-13.175-22.99-31.964-22.99-52.819 0-10.223 2.126-19.95 5.96-28.763m33.785-35.73a71.652 71.652 0 0 1 19.873-6.588",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#m)",
    strokeWidth: 0.523,
    d: "m156.699 210.02 9.936-24.057 73.738 24.057",
    opacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#n)",
    strokeWidth: 0.523,
    d: "m324.315 165.568-24.056-9.936 24.056-73.738",
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5C5C5C",
    d: "M135.445 112.305c-.365 0-.78-.182-1.095-.365-9.029-5.61-11.934-7.236-11.934-12.498V86.927c0-1.809.514-2.44 2.207-3.07 2.888-1.112 6.706-2.573 9.594-3.619.432-.15.813-.265 1.228-.265.415 0 .797.116 1.228.265 2.905.996 6.689 2.507 9.577 3.619 1.71.647 2.225 1.261 2.225 3.07v12.515c0 5.262-2.839 7.004-11.951 12.498-.299.183-.73.365-1.079.365Zm0-1.294c.282 0 .631-.199.88-.382 7.701-5.013 10.921-6.357 10.921-11.32V87.16c0-1.195-.232-1.626-1.079-1.958-1.809-.68-7.933-3.037-9.742-3.718-.415-.166-.764-.266-.98-.266-.232 0-.581.084-.979.266-1.809.68-7.95 3.004-9.743 3.718-.863.332-1.079.764-1.079 1.959v12.15c0 4.962 3.17 6.356 10.905 11.319.266.183.597.382.896.382Zm-1.776-7.834c-.265 0-.431-.1-.63-.332l-4.947-5.76c-.116-.166-.199-.348-.199-.514 0-.366.282-.614.614-.614.216 0 .399.082.565.282l4.564 5.361 8.316-12.947c.149-.199.348-.348.564-.348.315 0 .614.282.614.597 0 .15-.083.332-.149.465l-8.698 13.478c-.166.215-.365.332-.614.332Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M30 11h461v261H30z",
    style: {
      mixBlendMode: "overlay"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 357.744,
    height: 210.333,
    x: 3.128,
    y: 1.128,
    stroke: "#DEE0E2",
    strokeWidth: 0.256,
    rx: 8.052
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 266.366,
    x2: 286.517,
    y1: 143.256,
    y2: 148.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 259.157,
    x2: 259.157,
    y1: 86.882,
    y2: 62.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 112.003,
    x2: 129.315,
    y1: 164.903,
    y2: 162.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 74.309,
    x2: 75.878,
    y1: 292.279,
    y2: 220.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 74.638,
    x2: 75.011,
    y1: 359.969,
    y2: 223.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 76.971,
    x2: 76.187,
    y1: 279.924,
    y2: 209.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 87.807,
    x2: 67.899,
    y1: 62.278,
    y2: 25.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 68.553,
    x2: 73.309,
    y1: 2.636,
    y2: 36.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 127.055,
    x2: 136.2,
    y1: 26.666,
    y2: 8.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 132.811,
    x2: 128.545,
    y1: 34.027,
    y2: 12.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 198.536,
    x2: 198.536,
    y1: 185.963,
    y2: 210.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 300.259,
    x2: 324.315,
    y1: 123.731,
    y2: 123.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 491,
    x2: 30,
    y1: 11,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#905DCF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 358,
    height: 210.588,
    x: 3,
    y: 1,
    fill: "#fff",
    rx: 8.179
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.442 70.576h50.989v50.989h-50.989z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 363.616,
    height: 216.204,
    x: 0.192,
    y: 0.298,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.106
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.404
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10447_4825"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10447_4825",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAonAdvancedSetupMobile);
export default __webpack_public_path__ + "static/media/AonAdvancedSetup_mobile.1df3e249cfa9383defcdd3a6189098b4.svg";
export { ForwardRef as ReactComponent };